import { BroadcastData, BroadcastStatus } from '../../common/types/broadcast';
import {
    AccessLevel,
    CloudRecordingStatus,
    ConnectionType,
    MediaPlatform,
    RoomConferenceState,
    SummarizationMailRecipient,
    SummarizationStatus,
} from '../../common/types/conferences';
import { AvatarPlaceholderData, ReactionType } from '../../common/types/user-info';
import { emotions } from './shared/constants';
import { Role } from './shared/helpers/permissions';

export type {
    User,
    GetMeUserResponse,
    AvatarPlaceholder,
    UserUid,
    YandexUid,
    DisplayName,
    AvatarUrl,
    AvatarPlaceholderData,
} from '../../common/types/user-info';

export type { LogoOrganization } from '../../common/types/logo-organization';

export { BroadcastStatus, SummarizationMailRecipient, AccessLevel, MediaPlatform, ConnectionType };
export type { BroadcastData, ReactionType, CloudRecordingStatus, SummarizationStatus, RoomConferenceState };

export type TelemostAgent =
    | 'room-agent'
    | 'translator'
    | 'telemost'
    | 'telemost-messenger'
    | 'meeting-room'
    | 'telemost-iframe';

export type EmptyObject = Record<string, never>;

export type ChatData = {
    chat_path: string;
};

export type AnyRestable = Record<string | number | symbol, unknown>;

export type PeerId = string;

export type ReactionReason = 'click' | 'post-message';

export type EmotionType = (typeof emotions)[number];

export interface ReactionState {
    reactionType: ReactionType | null;
    timestamp: number;
    suppressible: boolean;
}

export interface Emotion {
    peerId: PeerId;
    emotionType: EmotionType;
    showDeadline: number;
    duration: number;
}

export type EmotionState = Omit<Emotion, 'peerId'> | null;

export enum ReleasePhase {
    NDA = 'nda',
    BETA = 'beta',
}

export type NotUndefined = NonNullable<unknown> | null;

export interface ParticipantInfo {
    peer_id: string;
    display_name: string;
    uid: string;
    is_default_avatar?: boolean;
    avatar_url?: string;
    role?: Role;
    avatar_placeholder?: AvatarPlaceholderData;
}

export interface ConferenceStateInfo {
    version: number;
    state: RoomConferenceState;
}
